/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class Documents<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Documents
   * @name InvoicesList
   * @request GET:/Documents/Invoices
   * @secure
   */
  invoicesList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Documents/Invoices`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Documents
   * @name InvoiceDetail
   * @request GET:/Documents/Invoice/{invoiceId}
   * @secure
   */
  invoiceDetail = (invoiceId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Documents/Invoice/${invoiceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
